'use client';

import { BlogCardContainer } from '../../../components/common/cards/Blog/BlogCardContainer';
import { IBlogItemEntry } from '../../../contentful/types/IBlogItemEntry';
import BlogCard from '../../../components/common/cards/Blog/BlogCard';
import { PageRoutes } from '../../app/pages/domain/constants/PageRoutes';
import { getCardImageSource } from '../../../utils/getCardImageSource';

interface IBlogSectionHomeCards {
	data: IBlogItemEntry[];
}

export default function BlogSectionHomeCards({ data }: IBlogSectionHomeCards) {
	return (
		<BlogCardContainer>
			{data.map((item: IBlogItemEntry) => (
				<BlogCard
					key={item.id}
					title={item.fields.title}
					body={item.fields.body}
					imageSource={getCardImageSource(item.fields.image)}
					imageAlt={
						item.fields.image?.fields.description ??
						item.fields.image?.fields.title
					}
					linkHref={`${PageRoutes.Blogs}/item/${item.fields.slug}`}
					publicationDate={item.fields.publicationDate}
				/>
			))}
		</BlogCardContainer>
	);
}
